export const ACRONYM_TITLES = {
  mcs: "Mètres cubes par seconde",
  mch: "Mètres cubes par heure",
};

export function getAcronymTitle(code = "") {
  const normalizedCode = String(code).trim().toLowerCase();
  return ACRONYM_TITLES[normalizedCode] || normalizedCode;
}

export function getAcronymAbbrHtml(code = "") {
  const normalizedCode = String(code).trim().toLowerCase();
  const title = getAcronymTitle(normalizedCode);
  if (!normalizedCode) {
    return "";
  }

  return `<abbr class="unit-acronym" title="${title}">${normalizedCode}</abbr>`;
}
